/**
    商品列表
**/
<template>
        <div class="rightaside_content">
          <h3 class="headerTitle">我的订单</h3>
          <el-tabs type="border-card" v-loading='loading' v-model="activeName"  @tab-click="tabhandleClick">
            <el-tab-pane name=0>
                <span slot="label">退款退货</span>
                <div class="tab_pane_content">
                   <div v-for="item in orderInfoList" :key="item.oid" :class="item.status==1?'orderbox_info redBorder':'orderbox_info'">
                        <div class="orderbox_info_header">
                           <div class="orderbox_info_ordNum"> 
                                <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                                <span>{{item.bxunyouMerchant!=null?item.bxunyouMerchant.name:'--'}}</span> <el-divider direction="vertical"></el-divider>
                                <span>退单号： <i>{{item.asOid}}</i></span> <el-divider direction="vertical"></el-divider>
                            </div>
                            <div>
                                <p class="order_money">申请金额：<i >{{item.refundAmount || 0.00}}</i> 元</p>
                                <p class="order_money">实际退款：<i >{{item.refundAmount || 0.00}}</i> 元</p>
                            </div>
                        </div>
                        <el-row class="order_goods_whole">
                            <el-col :span="20">
                                <el-row class="order_goods">
                                    <el-col :span="2"> 
                                      <el-image :src="`${(item.commodity.photos!=undefined || item.commodity.photos!=null) ?item.commodity.photos:''}`">
                                            <div slot="error" class="image-slot">
                                                <i class="el-icon-picture-outline"></i>
                                            </div>
                                        </el-image>
                                    </el-col> 
                                    <el-col :span="15" class="order_Info_item">
                                        <p>{{item.commodity.name}} <span style="color:#ff6700">{{item.commodity.specificationlist.length>0?item.commodity.specificationlist[0].attributeContent:'默认规格'}}</span></p>
                                        <!-- <p>{{item.commodity.name}}  {{item.commodity.specificationlist[0].name}}</p> -->
                                        <p v-if="item.bxysid!=-1">{{item.commodity.realprice||item.commodity.price}} * {{item.commodity.number || 1 }}</p>
                                        <p v-if="item.bxysid==-1">{{item.refundAmount||0}}</p>
                                       </el-col>
                                             
                                </el-row>
                            </el-col>
                            <el-col :span="4">
                                <el-button class="buttonStyle" @click="gotoDetail(item)">退单详情</el-button>
                            </el-col>
                        </el-row>
                   </div>
                    <div class="noData" v-if="orderInfoList.length==0?true:false">
                             您还没有相关订单。
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <!-- <el-row>
          <el-col :span="24" class="pagination">
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          </el-col>
        </el-row> -->
        </div>
</template>
<script>
import Pagination from '@/components/Pagination'
import {searchOrder,showorderList,cancleOrderItem,removeOrderItem,payStatus,xy_personvalue,confirmRceiptItem,backMoneyList} from '@/api/xunyou'
export default {
  
  data() {
    return {       
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        loading:false,
        activeName:0,
        searchValue:'',        
        orderInfoList:[
        ],
        closeValue:'',
        finishiValue:'',
        waitGetValue:'',
        waitSendValue:'',
        waitpayValue:'',
        allValue:'',
         // 请求数据参数
        formInline: {
            pageSize: 10,
            pageNum: 1,
            uid:JSON.parse(localStorage.getItem("userdata")).userId,
        },
        // 分页参数
        pageparm:{
            pageSize:10,
            currentPage:1,
            total:0,
        },
        
    };
  },
      // 注册组件
  components: {Pagination},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){
      if(this.$route.fullPath.indexOf('tap')>0){
          this.activeName =this.$route.query.tap
      }
      
      if(this.$route.fullPath.indexOf('orderNumer')>0){
          this.getPayStatus()
        //   this.getshoworderList(this.activeName)
      }else{
          this.getshoworderList(this.activeName)
      }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getshoworderList(this.activeName)
    },
      // // 查询支付状态
      getPayStatus() {
         payStatus({
             out_trade_no: this.$route.query.orderNumer  
         })
            .then(res => {
                // console.log('res路径',res,res.alipay_trade_query_response.code==10000 , res.alipay_trade_query_response.trade_status=='TRADE_SUCCESS')
                if(res.alipay_trade_query_response.code==10000 && res.alipay_trade_query_response.trade_status=='TRADE_SUCCESS'){
                    // console.log('杨老板接口进来了吗')
                   xy_personvalue({
                        orderId:this.$route.query.orderNumer   // 这个需要处理重新获值
                    })
                        .then(res => {
                            // console.log(res,'杨老板接口进来了吗')
                            this.getshoworderList(this.activeName)
                            // this.$message.error('调取失败失败，请稍后再试！')
                        })
                        .catch(err => {
                        this.$message.error('查询失败，请稍后再试！')
                        })
                }
            })
            .catch(err => {
                
            })
    },
    //   切换tab
      tabhandleClick(tab, event) {
        // getshoworderList
        console.log(this.activeName,tab, event,'tab切换');
        this.getshoworderList(this.activeName)
    //    this.getshoworderList(1);
      },

    // 订单查询
     getshoworderList(status,value){
         this.loading =true
        backMoneyList(this.formInline)
            .then(res => {
              if (res.code == 0) {
                  this.orderInfoList = res.rows
                  this.loading = false
                    // 分页赋值
                this.pageparm.currentPage = this.formInline.pageNum
                this.pageparm.pageSize = this.formInline.pageSize
                this.pageparm.total = res.total
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('订单查询失败，请稍后再试！')
            })
      },

    //   订单状态转换
    orderStatus(status){
        switch(status) {
            case 1:
                return '等待买家付款'
                break;
            case 2:
                 return '等待卖家发货'
                break;
            case 3:
                 return '等待买家确认收货'
                break;
            case 4:
                 return '交易成功'
                break;
            case 5:
                 return '交易关闭'
                break;
            default:
                
                return '--'
        } 
    },

    // // 搜索功能
    // searchHandle(value){
    //     this.getshoworderList(this.activeName,value)
    // },

// // 确认收货
//     confirmRceipt(item){
//         console.log(item,'确认收货')
//         confirmRceiptItem({oid:item.oid}).then(res => {
//               if (res.code == 0) {
//                 this.$message({
//                     type: 'success',
//                     message: '确认收货成功!'
//                 });
//                  this.getshoworderList(this.activeName)
//               } else {
//                 this.$message({
//                   type: 'info',
//                   message: res.msg
//                 })
//               }
//             })
//             .catch(err => {
//               this.editFormVisible = false
//               this.loading = false
//               this.$message.error('确认收货失败，请稍后再试！')
//             }) 
//     },

    // 订单详情
    gotoDetail(item){
        console.log(item,'订单详情')
        // sessionStorage.setItem("orderDetail", JSON.stringify(item));
        this.$router.push(`/refundDetail?refund=1&returnOrder=${item.asOid}&bXyOasid=${item.bXyOasid}`)
   },

    // // 立即支付
    // payOrderNow(amount,orderGoodsInfo){
    //     sessionStorage.setItem("account", JSON.stringify(amount)); 
    //     sessionStorage.setItem("orderGoodsInfo", JSON.stringify([orderGoodsInfo])); 
    //     this.$router.push('/orderNow')
    // },

    // //   取消订单
    //  cancleOrder(orderId) {
    //     this.$confirm('确定取消订单?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //          cancleOrderItem({oid:orderId}).then(res => {
    //           if (res.code == 0) {
    //             this.$message({
    //                 type: 'success',
    //                 message: '取消成功!'
    //             });
    //              this.getshoworderList(this.activeName)
    //           } else {
    //             this.$message({
    //               type: 'info',
    //               message: res.msg
    //             })
    //           }
    //         })
    //         .catch(err => {
    //           this.editFormVisible = false
    //           this.loading = false
    //           this.$message.error('查询红包失败，请稍后再试！')
    //         })          
    //     }).catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已取消'
    //       });          
    //     });
    //   },

    // //   移出订单
    // removeOrder(orderId){
    //     this.$confirm('确定移除订单吗?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //        removeOrderItem({oid:orderId}).then(res => {
    //           if (res.code == 0) {
    //             this.$message({
    //                 type: 'success',
    //                 message: '移除成功!'
    //             });
    //              this.getshoworderList(this.activeName)
    //           } else {
    //             this.$message({
    //               type: 'info',
    //               message: res.msg
    //             })
    //           }
    //         })
    //         .catch(err => {
    //           this.editFormVisible = false
    //           this.loading = false
    //           this.$message.error('移除失败，请稍后再试！')
    //         })   
    //     }).catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已移除'
    //       });          
    //     });
    // },

//    nextEditResource(){
//        this.$refs.sizeForm.validate((valid) => {
//           if (valid) {
//             if(this.sizeForm.checkedBox){
//                 this.errerInfo=false;
//                 this.$router.push(`/merchantForm?type=${this.$route.query.type}`)
//             }else{
//                 this.errerInfo=true;
//             }
//           }
//         });
//    }

  },
};
</script>

<style scoped lang="less">


// .rightaside{
//     background: white;
//     margin-left: 15px;
//     padding: 20px !important;
    .rightaside_content{
        .orderbox_info_ordNum{
            position: relative;
            bottom: -60px;
        }
        .headerTitle{
            font-size: 20px;
            height: 40px;
            line-height: 40px;
            color: #666;
        }
        /deep/.el-tabs--border-card{
            border: 0px;
            box-shadow: unset;
            .el-tabs__header{
                border-bottom: 0px;
                background: white;
               /deep/ .el-tabs__item.is-active {
                    color:  #ff6700;
                    background-color: transparent;
                    border-right-color: transparent;
                    border-left-color: transparent;
                }
            }
        }
        .search_box {
            text-align: right;
            margin-bottom: 10px;
            .input-with-select.el-input.el-input-group.el-input-group--append {
                width: 40%;
            }
        }
        .redBorder {
            border: 1px solid #ff6700 !important;
        }
        .orderbox_info {
            // padding: 20px;
            // box-sizing: border-box;
            margin-bottom: 10px;
             border: 1px solid#ccc;
            .orderbox_info_header {
                padding: 20px;
                box-sizing: border-box;
                border-bottom: 1px solid #ccc;
                display: flex;
                justify-content: space-between;
                p{
                    font-size: 16px;
                    color: #ff6700;
                    margin-bottom: 5px;
                }
                .order_money i{
                    font-size: 26px;
                    color: #ff6700;
                }
            }
            .order_goods_whole {
                padding: 20px;
                box-sizing: border-box;
                .order_goods {
                    margin-bottom: 20px;
                    .order_Info_item {
                        margin-left: 12px;
                    }
                }
                button.el-button.buttonStyle {
                    padding: 6px 30px;
                    font-size: 12px;
                    margin-bottom: 6px;
                    margin-left: 0;
                }
                .dangerBg.buttonStyle{
                    background-color:  #ff6700;
                    border-color:  #ff6700;
                }
                .el-button--danger.is-plain{
                    background: white;
                }
                .el-button--danger:focus, .el-button--danger:hover{
                    color: white;
                    background: #F56C6C;
                }
            }
        }
        .tab_pane_content{
            .noData{
                text-align: center;
                height: 200px;
                line-height: 200px;
            }
        }

    }
// }
.pagination{
  text-align: right;
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #ff6700;
      color: #FFF;
      width: 20px;
  }
  /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
    width: 20px;
  }
  /deep/input[disabled], input[disabled="disabled"], input[readonly], input[readonly="readonly"] {
      background-color: transparent;
  }
}

</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/customerService/refund.vue